<script>
/* jshint esversion: 6 */
import { watch, computed, inject} from 'vue';
import './../func.common';
import { FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default{
    name: 'SwitchField',
    components: {
        'font-awesome-icon' : FontAwesomeIcon
    },
    props: {
		'hinted': {type:String},
        'disabled': {type: Boolean},
        'id': { type: String, default: ''}, 
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
	},
	setup(props) {
        const validateChild = inject('validateChild');
        const helperName = computed(() => {
            return props.model[props.schema.model];
        });

        watch(helperName, (newVal, oldVal) => {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.model,
                'validator': props.schema.validator,
            };
            if (validateChild) {
                validateChild(toParent);
            }
        });
	}
};
</script>
<template>
<div class="vueFormFieldMain">
    <div class="fieldSwitch" :class="[schema.class, disabled === true ? 'fieldDisabled': '']">
        <component is="style">
            .switchMainLabel {
                font-family: {{schema.switchFont}};
                position: relative;
                display: block;
                width: {{schema.switchWidth}}px;
                height:{{schema.switchHeight}}px;
                padding: 0;
                margin: 0 10px 10px 0;
                border-radius: calc({{schema.switchHeight}} / 2);
                box-shadow: inset 0 -1px white, inset 0 1px 1px rgba(0, 0, 0, 0.05);
                cursor: pointer;
            }
            .switchInput {
                position: absolute;
                top: 0;
                left: 0;
                opacity: 0;
            }

            .switchInput:checked ~ span .switchHandle {
                left: {{ schema.switchWidth }} - ({{schema.switchHeight-1}} - 1px);
                left: calc(100% - ({{schema.switchHeight-2}}px));
                box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);
            }
            .switchHandle {
                position: absolute;
                top: 1px;
                left: 1px;
                width: {{schema.switchHeight-2}}px;
                height: {{schema.switchHeight-2}}px;
                background: linear-gradient(to bottom, #ffffff 40%, #f0f0f0);
                background-image: -webkit-linear-gradient(top, #ffffff 40%, #f0f0f0);
                border-radius: 100%;
                box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
            }
            .switchHandle:before {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                margin: -6px 0 0 -6px;
                width: 12px;
                height: 12px;
                background: linear-gradient(to bottom, #eeeeee, #ffffff);
                background-image: linear-gradient(rgb(238, 238, 238), rgb(255, 255, 255));
                background-image: -webkit-linear-gradient(top, #eeeeee, #ffffff);
                border-radius: 6px;
                box-shadow: inset 0 1px rgba(0,0,0,.02);
            }
            .labelforswitch {
                position: relative;
                display: block;
                height: {{ schema.switchHeight }}px;
                font-size: 10px;
                text-transform: uppercase;
                background: {{ schema.switchGrey }};
                color: #000000;
                border-radius: {{ schema.switchBorderRadius }}px;
                box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.12), inset 0 0 2px rgba(0, 0, 0, 0.15);
            }
            .labelforswitch:before,
            .labelforswitch:after {
                position: absolute;
                top: 50%;
                margin-top: -0.5em;
                line-height: 1;
                -webkit-transition: inherit;
                -moz-transition: inherit;
                -o-transition: inherit;
                transition: inherit;
            }	
            .labelforswitch:before {
                content: attr(data-off);
                right: 11px;
                color: #000000;
                text-shadow: 0 1px rgba(255, 255, 255, 0.5);
            }
            .labelforswitch:after {
                content: attr(data-on);
                left: 11px;
                color: #ffffff;
                text-shadow: 0 1px rgba(0, 0, 0, 0.2);
                opacity: 0;
            }	
            .switchInput:checked ~ span .labelforswitch {
                background: {{schema.switchOn}};
                box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15), inset 0 0 3px rgba(0, 0, 0, 0.2);
            }
            .switchInput:checked ~ span  .labelforswitch:before {
                opacity: 0;
            }
            .switchInput:checked ~ span  .labelforswitch:after {
                opacity: 1;
            }
            .labelforswitch,
            .switchHandle {
                transition: all 0.3s ease;
            }
        </component>
        <div class="form-group row gy-2 gx-3-align-items-left switchmain">
            <div class="col-sm-12">
                <span class="labelSwitch" v-if="schema.label && schema.label.length > 0">
                    {{ schema.label }} 
                </span>
                <br>
                <label class="switchMainLabel" :style="disabled === true ? 'opacity: 0.5; cursor:not-allowed; pointer-events:none': ''">
                    <input 
                        type="checkbox" 
                        :value="model[schema.model]"
                        :id="schema.idLabel"
                        v-model="model[schema.model]"
                        class="switchInput"
                        :style="disabled === true ? 'pointer-events:none' : ''"
                    >
                    <span :style="disabled === true ? 'pointer-events:none' : ''">
                        <label 
                            :data-on="schema.textOn || 'On'"
                            :data-off="schema.textOff || 'Off'"
                            :for="schema.idLabel"
                            class="labelforswitch"
                            :style="disabled === true ? 'pointer-events:none' : ''"
                        ></label>
                        <span class="switchHandle" :style="disabled === true ? 'pointer-events:none' : ''"></span>
                    </span>
                </label>
                <div class="hint" v-if="hinted && hinted.length > 0">{{ hinted }}</div>
                <div class="vueFormSmall labelred" v-if="schema.errorShow === true">
                    <font-awesome-icon class="errorExclamationMarkColor" icon="fa-solid fa-exclamation"></font-awesome-icon>
                    |  {{ schema.errorText[0] }}
                </div>
            </div>
        </div>
    </div>
</div>
</template>